import { ISourceDataConfigurationForm } from "@/api/dtos";
import { createVersions, ISelectionOption, IUpdateMapping, updateBySelection, updateVersion } from ".";

export const ConfigurationUpdateFormMapping: IUpdateMapping = {
    createOptions: (source, target) => {
        let options: ISelectionOption[] = [
            {
                name: 'options',
                label: 'Options',
                options: [
                    {
                        name: 'overrideName',
                        label: 'Override Name',
                        update: (source, target, sourceValue, targetValue, newValue) => {
                            (newValue as ISourceDataConfigurationForm).name = (sourceValue as ISourceDataConfigurationForm).name;
                        }
                    },
                    {
                        name: 'priority',
                        label: 'Priority',
                        update: (source, target, sourceValue, targetValue, newValue) => {
                            (newValue as ISourceDataConfigurationForm).priority = (sourceValue as ISourceDataConfigurationForm).priority;
                        }
                    },
                    {
                        name: 'excludeBlank',
                        label: 'Hide Form When No Data Provided',
                        update: (source, target, sourceValue, targetValue, newValue) => {
                            (newValue as ISourceDataConfigurationForm).excludeBlank = (sourceValue as ISourceDataConfigurationForm).excludeBlank;
                        }
                    },
                    {
                        name: 'alerts',
                        label: 'Alerts',
                        options: [
                            {
                                name: 'information',
                                label: 'Information',
                                update: (source, target, sourceValue, targetValue, newValue) => {
                                    (newValue as ISourceDataConfigurationForm).alertInformation = (sourceValue as ISourceDataConfigurationForm).alertInformation;
                                }
                            },
                            {
                                name: 'warning',
                                label: 'Warning',
                                update: (source, target, sourceValue, targetValue, newValue) => {
                                    (newValue as ISourceDataConfigurationForm).alertWarning = (sourceValue as ISourceDataConfigurationForm).alertWarning;
                                }
                            },
                            {
                                name: 'error',
                                label: 'Error',
                                update: (source, target, sourceValue, targetValue, newValue) => {
                                    (newValue as ISourceDataConfigurationForm).alertError = (sourceValue as ISourceDataConfigurationForm).alertError;
                                }
                            },
                            {
                                name: 'success',
                                label: 'Success',
                                update: (source, target, sourceValue, targetValue, newValue) => {
                                    (newValue as ISourceDataConfigurationForm).alertSuccess = (sourceValue as ISourceDataConfigurationForm).alertSuccess;
                                }
                            }
                        ]
                    },
                    {
                        name: 'discrepancyNotes',
                        label: 'Discrepancy Notes',
                        options: [
                            {
                                name: 'showNotes',
                                label: 'Show Discrepancy Notes',
                                update: (source, target, sourceValue, targetValue, newValue) => {
                                    (newValue as ISourceDataConfigurationForm).showNotes = (sourceValue as ISourceDataConfigurationForm).showNotes;
                                }
                            },
                            {
                                name: 'types',
                                label: 'Types',
                                update: (source, target, sourceValue, targetValue, newValue) => {
                                    (newValue as ISourceDataConfigurationForm).noteTypes = (sourceValue as ISourceDataConfigurationForm).noteTypes;
                                }
                            },
                            {
                                name: 'statuses',
                                label: 'Statuses',
                                update: (source, target, sourceValue, targetValue, newValue) => {
                                    (newValue as ISourceDataConfigurationForm).noteStatuses = (sourceValue as ISourceDataConfigurationForm).noteStatuses;
                                }
                            }
                        ]
                    }
                ]
            }
        ];

        if (source.formVersionMetadata?.sections && source.formVersionMetadata.sections.length !== 0) {
            options.push({
                name: 'versions',
                label: 'Versions',
                options: source.formMetadata?.versions?.map(x => ({
                    name: x.id!,
                    label: `${x.name}`,
                    update: (source, target, sourceValue, targetValue, newValue) => {
                        const typedNewValue = (newValue as ISourceDataConfigurationForm);
                        const typedTargetValue = (targetValue as ISourceDataConfigurationForm);
                        const typedSourceValue = (sourceValue as ISourceDataConfigurationForm);
                        
                        if (!typedNewValue.linked) {
                            createVersions(typedSourceValue, typedTargetValue, typedNewValue, target.formMetadata)
                        }

                        typedNewValue.versions = {...typedNewValue.versions};
                        updateVersion(typedSourceValue, typedTargetValue, typedNewValue, x.id!, target.formMetadata);
                    }
                }))
            });
        }

        return options;
    },
    update: (source, target, sourceValue, targetValue, options, selection) => {
        const newValue = { 
            ...targetValue
        };

        updateBySelection(source, target, sourceValue, targetValue, newValue, options, selection);

        return newValue;
    }
}